import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2097_2906)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M16 10.53c0-3.276-2.193-5.54-6.053-5.54H4.258l-2.624.12.152.395 2.091-1.81 2.447-2.417a.73.73 0 0 0 .203-.523C6.527.309 6.231 0 5.774 0a.82.82 0 0 0-.542.24L.254 5.188A.78.78 0 0 0 0 5.762c0 .206.085.403.254.566l4.978 4.947c.144.155.364.24.542.24.457 0 .753-.308.753-.754a.73.73 0 0 0-.203-.523l-2.447-2.41-2.09-1.817-.153.394 2.624.12h5.816c2.887 0 4.41 1.612 4.41 3.919 0 2.315-1.523 4.03-4.41 4.03H8.127a.743.743 0 0 0-.77.763c0 .42.304.763.77.763h1.955C13.868 16 16 13.813 16 10.53"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2097_2906" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }